var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestricted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 29C16.2044 29 15.4413 29.3161 14.8787 29.8787C14.3161 30.4413 14 31.2044 14 32C14 32.7956 14.3161 33.5587 14.8787 34.1213C15.4413 34.6839 16.2044 35 17 35H47C47.7957 35 48.5587 34.6839 49.1213 34.1213C49.6839 33.5587 50 32.7956 50 32C50 31.2044 49.6839 30.4413 49.1213 29.8787C48.5587 29.3161 47.7957 29 47 29H17Z",
    fill: "#FF000F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 32C64 40.4869 60.6286 48.6263 54.6274 54.6274C48.6263 60.6286 40.4869 64 32 64C23.5131 64 15.3737 60.6286 9.37258 54.6274C3.37142 48.6263 0 40.4869 0 32C0 23.5131 3.37142 15.3737 9.37258 9.37258C15.3737 3.37142 23.5131 0 32 0C40.4869 0 48.6263 3.37142 54.6274 9.37258C60.6286 15.3737 64 23.5131 64 32ZM58 32C58 25.1044 55.2607 18.4912 50.3848 13.6152C45.5088 8.73928 38.8956 6 32 6C25.1044 6 18.4912 8.73928 13.6152 13.6152C8.73928 18.4912 6 25.1044 6 32C6 38.8956 8.73928 45.5088 13.6152 50.3848C18.4912 55.2607 25.1044 58 32 58C38.8956 58 45.5088 55.2607 50.3848 50.3848C55.2607 45.5088 58 38.8956 58 32Z",
    fill: "#FF000F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestricted);
export default __webpack_public_path__ + "static/media/restricted.d19c978e40f409e865f54778daeb195d.svg";
export { ForwardRef as ReactComponent };